import classNames from "classnames";

import { roundAndDropTrailingZeros } from "@ascendnow/shared";

import { ArrowLeftIcon } from "../AscIcons";
import styles from "./AscRankStats.module.scss";

export interface AscRankStatsProps {
  className?: string;
  globalRank: number;
  globalRankIncrease: number;
  schoolRank: number;
  schoolRankIncrease: number;
  totalPoints: number;
}

export default function AscRankStats({
  className,
  globalRank,
  globalRankIncrease,
  schoolRank,
  schoolRankIncrease,
  totalPoints,
}: AscRankStatsProps) {
  function statBox(
    label: string,
    count: number,
    growth?: "increase" | "decrease"
  ) {
    return (
      <div
        className={classNames(styles.statBox, {
          [styles.increase]: growth === "increase",
          [styles.decrease]: growth === "decrease",
        })}
      >
        <div className={styles.stat}>
          <span className={styles.statCount}>
            {roundAndDropTrailingZeros(count)}
          </span>
          <ArrowLeftIcon className={styles.arrow} />
        </div>
        <div className={styles.label}>{label}</div>
      </div>
    );
  }

  return (
    <div
      data-testid="asc-rank-stats"
      className={classNames(styles.ground, className)}
    >
      {statBox(
        "Global Rank",
        globalRank,
        globalRankIncrease > 0
          ? "increase"
          : globalRankIncrease < 0
          ? "decrease"
          : undefined
      )}
      {statBox(
        "School Rank",
        schoolRank,
        schoolRankIncrease > 0
          ? "increase"
          : schoolRankIncrease < 0
          ? "decrease"
          : undefined
      )}
      {statBox("Total Points", totalPoints)}
    </div>
  );
}
